import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { readinessActions as A } from '../../store/readinessSlice';
import { signOutAccount } from '../../services/readinessService';

/**
 * 60px white header: logo (→ homepage, with a save-progress prompt when
 * there's unsaved work) · centered progress (chat only) · mobile score
 * pill · Email my report · Sign in / signed-in email pill + Sign out.
 */
export default function ReadinessHeader({ progress, score, scoreColor, showProgress, showHeaderScore }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const account = useSelector((s) => s.readiness.account);
  const email = useSelector((s) => s.readiness.email);
  const answers = useSelector((s) => s.readiness.answers);
  const msgs = useSelector((s) => s.readiness.msgs);

  const hasProgress = Object.keys(answers).length > 0 || msgs.some((m) => m.kind === 'user');

  const goHome = () => {
    // Signed-in users' progress is already tied to their email; anonymous
    // users with real progress get a chance to save it before leaving.
    if (!account && hasProgress) {
      dispatch(A.openLeave());
      return;
    }
    navigate('/');
  };

  return (
    <header className="rdz-header">
      <a
        href="/"
        className="rdz-header__logo-link"
        aria-label="Back to LoanKnow homepage"
        onClick={(e) => { e.preventDefault(); goHome(); }}
      >
        <img src="/assets/loanknow-logo.svg" alt="LoanKnow" className="rdz-header__logo" />
      </a>
      <div className="rdz-header__center">
        {showProgress && (
          <>
            <span className="rdz-header__progress-label">{progress.label}</span>
            <div className="rdz-header__progress-track">
              <div className="rdz-header__progress-fill" style={{ width: progress.pct }} />
            </div>
          </>
        )}
      </div>
      {showHeaderScore && (
        <div className="rdz-header__score-pill">
          <span className="rdz-header__score-dot" style={{ background: scoreColor }} />
          <span className="rdz-header__score-num">{score}</span>
        </div>
      )}
      <button type="button" className="rdz-btn-tint" onClick={() => dispatch(A.openReport())}>
        Email my report
      </button>
      {account ? (
        <div className="rdz-header__account">
          <span className="rdz-header__email-pill">
            <span className="rdz-header__email-dot" />
            {email}
          </span>
          <button
            type="button"
            className="rdz-btn-ghost-outline"
            onClick={() => { signOutAccount(); dispatch(A.setAccount(false)); }}
          >
            Sign out
          </button>
        </div>
      ) : (
        <button type="button" className="rdz-btn-ghost-outline" onClick={() => dispatch(A.openSignin())}>
          Sign in
        </button>
      )}
    </header>
  );
}
